import React from 'react';
import { convertPlatformLogs } from './convertPlatformLogs';
import { v4 as uuid } from 'uuid';
import { ToolExecutionResult } from '../../../types';

interface useConsentClientToolProps {
  setLoadingsCount: Function;
  createLoggerWithMeasure: Function;
}

export const useConsentClientTool = ({
  setLoadingsCount,
  createLoggerWithMeasure,
}: useConsentClientToolProps) => {
  const consentHandler = React.useRef<(c: boolean) => void>(
    (_userConsent: boolean) => {
      throw new Error('consentHandler is not initialized');
    },
  );
  const [consentMessage, setConsentMessge] = React.useState<{
    message: string;
    resolve: (allow: boolean) => void;
  }>();

  return {
    consentTool: {
      consentWithMessage: {
        async execute(params: any, { message } = { message: 'n/a' }) {
          const p = new Promise<ToolExecutionResult>((resolve) => {
            setLoadingsCount((prev: number) => prev - 1);
            consentHandler.current = (payload) => {
              resolve({
                success: true,
                content: null as unknown as string,
                widgetResponse: JSON.stringify({
                  ...params,
                  userConsent: payload as boolean,
                }),
              });
              setConsentMessge(undefined);
              setLoadingsCount((prev: number) => prev + 1);
              // TODO - reset consentHandler.current
            };
          });
          setConsentMessge({
            resolve: consentHandler.current,
            message,
          });
          return p;
        },
        // @ts-expect-error
        beforeExecute(params: object, request: any) {
          if (!request) {
            return;
          }
          const logRequest = createLoggerWithMeasure(
            'Consent widget tool - before execute',
          );
          logRequest(convertPlatformLogs(request.logs), uuid());
        },
      },
    },
    consentMessage: consentMessage && {
      handler: consentMessage.resolve,
      role: 'consentController',
      content: `<<${JSON.stringify({
        widget: 'CONSENT_CONTROLLER',
        data: { text: consentMessage.message },
      })}>>`,
    },
  };
};
